/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TumDetailsBreakdownRow,
  TumDetailsBreakdownRow$inboundSchema,
} from "./tumdetailsbreakdownrow.js";

/**
 * Per-dimension billed token breakdown for the usage details table
 */
export type TumDetailsBreakdown = {
  /**
   * The breakdown dimension key (model, hook_source, provider, account_type, email, division_name, department_name, role, project_id) — the public telemetry dimension identifiers, so the same keys work as telemetry.query filters. project_id rows carry project UUIDs; clients map them to names.
   */
  key: string;
  /**
   * Top values by tokens in descending order, with the remainder rolled into 'Other'
   */
  rows: Array<TumDetailsBreakdownRow>;
};

/** @internal */
export const TumDetailsBreakdown$inboundSchema: z.ZodMiniType<
  TumDetailsBreakdown,
  unknown
> = z.object({
  key: z.string(),
  rows: z.array(TumDetailsBreakdownRow$inboundSchema),
});

export function tumDetailsBreakdownFromJSON(
  jsonString: string,
): SafeParseResult<TumDetailsBreakdown, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TumDetailsBreakdown$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TumDetailsBreakdown' from JSON`,
  );
}
